import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTemplateComponent } from './document-template.component';
import { AddDocumentTemplateComponent } from './add-document-template/add-document-template.component';
import { EditDocumentTemplateComponent } from './edit-document-template/edit-document-template.component';

import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentTemplateSignaturesComponent } from './document-template-signatures/document-template-signatures.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
	declarations: [
		DocumentTemplateComponent,
		AddDocumentTemplateComponent,
		EditDocumentTemplateComponent,
		DocumentTemplateSignaturesComponent,
	],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, DragDropModule],
	exports: [DocumentTemplateComponent],
})
export class DocumentTemplateModule { }
